<template>
  <div class="agreement-content">
    <div class="agreement-container">
      <div class="container-title">协议信息</div>
      <div class="container-body">
        <el-form label-width="100px" :inline="true">
          <el-col :span="12">
            <el-form-item label="协议编号:">
              <div class="ellipsis">{{ agreementDetail.agreementCode }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="协议名称:">
              <div class="ellipsis">{{ agreementDetail.agreementName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="协议甲方企业:">
              <div class="ellipsis">{{ agreementDetail.firstParty }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商企业:">
              <div class="ellipsis">{{ agreementDetail.supplierCompanyName }}</div>
            </el-form-item>
          </el-col>
          <el-col v-if="!agreementOrigin" :span="24">
            <el-form-item label="协议有效时间:" prop="date">
              <div class="ellipsis">
                {{ agreementDetail.startDate + '至' + agreementDetail.endDate }}
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="agreementOrigin" :span="12">
            <el-form-item label="协议有效时间:" prop="date">
              <div class="ellipsis">
                {{ agreementDetail.startDate + '至' + agreementDetail.endDate }}
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="agreementOrigin" :span="12">
            <el-form-item label="备注:" prop="remark">
              <div class="ellipsis">{{ agreementDetail.remark }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-tabs v-model="quickNavActive" class="tabs-area" type="card">
              <el-tab-pane label="采购执行企业" name="0">
                <div class="scrollbar">
                  <el-scrollbar wrap-style="overflow-x:hidden;" style="height: 100%">
                    <TableList
                      :loading="loading"
                      :table-data="tableData"
                      :table-label="tableLabel"
                      :index-show="indexShow"
                      @handleButton="handleButton"
                      @handleSortChange="handleSortChange"
                      @handleSelectionChange="handleSelectionChange"
                    ></TableList>
                  </el-scrollbar>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="!agreementOrigin" label="采购协议物料类别" name="1">
                <div class="scrollbar">
                  <el-scrollbar wrap-style="overflow-x:hidden;" style="height: 100%">
                    <div class="table">
                      <TableList
                        key="1"
                        style="width: 50%"
                        :loading="loading2"
                        :table-data="tableData3"
                        :table-label="tableLabel2"
                        :index-show="false"
                        @handleButton="handleButton"
                        @handleSortChange="handleSortChange"
                        @handleSelectionChange="handleSelectionChange"
                      ></TableList>
                      <TableList
                        key="2"
                        style="width: 50%"
                        :loading="loading2"
                        :table-data="tableData2"
                        :table-label="tableLabel2"
                        :index-show="false"
                        @handleButton="handleButton"
                        @handleSortChange="handleSortChange"
                        @handleSelectionChange="handleSelectionChange"
                      ></TableList>
                    </div>
                  </el-scrollbar>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <!--从scm集成过来的协议没有附件，备注样式修改-->
          <el-col v-if="!agreementOrigin" :span="24">
            <el-form-item label="备注:">
              <el-input
                v-model="agreementDetail.remark"
                type="textarea"
                disabled
                style="width: 725px; height: 60px"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col v-if="!agreementOrigin" :span="24">
            <el-form-item label="附件:">
              <div
                v-for="(item, index) in agreementDetail.agreementAttachment"
                :key="index"
                style="color: #0064c8; cursor: pointer; display: flex; align-items: center"
                @click="handleDownload(item.attachmentPath)"
              >
                <img
                  style="width: 12px; height: 16px; margin-right: 12px"
                  src="../../../../assets/img/agreement/file.png"
                />
                {{ item.attachmentName }}
              </div>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </div>

    <!--            2022/6/10迭代-->
    <div v-if="agreementOrigin" class="agreement-container">
      <div class="container-title">采购协议物料清单</div>
      <div class="container-body">
        <div style="margin-right: 20px">
          <TableList
            :loading="loading3"
            :table-data="tableData4"
            :table-label="tableLabel4"
            :index-show="true"
            @handleButton="handleButton3"
            @handleSortChange="handleSortChange3"
            @handleSelectionChange="handleSelectionChange3"
          >
            <template #categoryCode="slot">
              <div
                style="cursor: pointer; color: #0064c8; font-size: 12px; text-align: left"
                class="in2clamp"
                @click="checkDetail(slot.scope.row)"
              >
                {{ slot.scope.row.categoryCode }}
              </div>
            </template>
            <template #isAddProduct="slot">
              <div class="table-product-name">
                {{ formateAddProduct(slot.scope.row.hasSku) }}
              </div>
            </template>

            <template #operation="slot">
              <el-button type="text" @click="handleEditCategory(slot.scope.row)">编辑</el-button>
            </template>
          </TableList>
          <div class="pagination">
            <el-pagination
              :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="pager.currentPage"
              :page-size="productTagPage1.pageSize"
              :total="productTagPage1.pageTotal"
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="agreement-container">
      <div class="container-title">协议下商品清单</div>

      <div style="width: 100%; margin-bottom: 10px">
        <!-- <el-form ref="query" :inline="true" :model="query">
          <el-form-item label="商品编号:" prop="skuCode">
            <el-input v-model="query.skuCode" placeholder="商品编号"></el-input>
          </el-form-item>
          <el-form-item label="商品名称:" prop="skuName">
            <el-input v-model="query.skuName" placeholder="商品名称"></el-input>
          </el-form-item>
          <eui-btn @click="handleSearch">查询</eui-btn>
          <eui-btn type="secondary" @click="handleClear">重置</eui-btn>
        </el-form> -->
        <ESearch
          :data="filterInfo.data"
          :field-list="filterInfo.fieldList"
          class="margin-b20"
          @handleFilter="handleSearch"
          @handleReset="handleClear"
          @handleFocus="focusClassify"
        ></ESearch>
      </div>
      <div class="container-btn">
        <eui-btn @click="handleAddProduct">新增</eui-btn>
        <eui-btn @click="handleMultiAdjustPrice">多维度调价</eui-btn>

        <eui-btn @click="handleDeleteBatch">批量删除</eui-btn>
        <eui-btn :disabled="exportProductLoading" @click="handleExportProduct">商品导出</eui-btn>
        <eui-btn @click="handleImportPrice">导入调价</eui-btn>
        <eui-link lighten style="margin-left: 10px" @click="handleResultView">查看导入结果</eui-link>
      </div>

      <div class="container-body">
        <div style="margin-right: 20px">
          <TableList
            ref="table"
            :loading="loading1"
            :table-data="tableData1"
            :table-label="tableLabel1"
            :selection-show="true"
            row-key="priceId"
            :reserve-selection="true"
            @handleButton="handleButton1"
            @handleSortChange="handleSortChange1"
            @handleSelectionChange="handleSelectionChange1"
            @handleSelect="handleSelect"
            @handleSelectAll="handleSelectAll"
          >
            <template #skuName="slot">
              <div class="table-product-name">
                {{ slot.scope.row.skuName }}
              </div>
            </template>
            <template #image="slot">
              <img :src="slot.scope.row.defaultImage" style="width: 48px; height: 48px; border: 1px solid #d9d9d9" />
            </template>
            <template #agreementPrice="slot">
              <div v-if="slot.scope.row.operateSign == 0">
                <el-input
                  v-model="slot.scope.row.agreementPrice"
                  style="width: 110px"
                  @blur="adjustAgreementPrice(slot.scope.row)"
                ></el-input>
              </div>
              <div v-else>{{ slot.scope.row.agreementPrice }}</div>
            </template>
            <template #rate="slot">
              {{ slot.scope.row.price ? (slot.scope.row.agreementPrice ? formatRate(slot.scope.row) : '') : '-' }}
            </template>
            <template #status="slot">
              {{ formatConfirmStatus(slot.scope.row.confirmStatus) }}
            </template>
            <template #operateSign="slot">
              {{ formatOperateSign(slot.scope.row.operateSign) }}
            </template>
            <template #operation="slot">
              <eui-link
                v-if="slot.scope.row.operateSign != 0"
                lighten
                font-size="12"
                @click="handleAdjustPrice(slot.scope.row)"
              >
                调价
              </eui-link>
              <eui-link style="margin-left: 10px" lighten font-size="12" @click="handleDelete(slot.scope.row)">
                删除
              </eui-link>
            </template>
          </TableList>
          <div style="float: left; margin-left: 10px; margin-top: 30px">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全部数据</el-checkbox>
          </div>
          <div class="pagination">
            <el-pagination
              :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="productTagPage1.currentPage"
              :page-size="productTagPage1.pageSize"
              :total="productTagPage1.pageTotal"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 10px">
      <!-- <el-button v-if="!agreementOrigin" @click="handleConfirm">提交确认</el-button>
      <el-button @click="handleCancel">取消</el-button> -->

      <eui-btn @click="handleConfirm">提交确认</eui-btn>
      <eui-btn type="secondary" @click="handleCancel">取消</eui-btn>
    </div>
    <el-dialog :append-to-body="true" :visible.sync="categoryVisible" width="1000px" :close-on-click-modal="false">
      <el-button v-if="editFlag" style="float: right; margin-bottom: 10px" type="primary" @click="handleAddProduct">
        新增
      </el-button>
      <div>
        <TableList
          :loading="loading1"
          :table-data="tableData1"
          :table-label="tableLabel5"
          :index-show="true"
          @handleButton="handleButton1"
          @handleSortChange="handleSortChange1"
          @handleSelectionChange="handleSelectionChange1"
        >
          <template #skuName="slot">
            <div class="table-product-name">
              {{ slot.scope.row.skuName }}
            </div>
          </template>
          <template #image="slot">
            <img :src="slot.scope.row.defaultImage" style="width: 48px; height: 48px; border: 1px solid #d9d9d9" />
          </template>
          <template #rate="slot">
            {{ slot.scope.row.price ? (slot.scope.row.agreementPrice ? formatRate(slot.scope.row) : '') : '-' }}
          </template>
          <template #status="slot">
            {{ formatConfirmStatus(slot.scope.row.confirmStatus) }}
          </template>
          <template #operateSign="slot">
            {{ formatOperateSign(slot.scope.row.operateSign) }}
          </template>
          <template #operation="slot">
            <el-button type="text" @click="handleDelete(slot.scope.row)">删除</el-button>
          </template>
        </TableList>
        <div class="pagination">
          <el-pagination
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="productTagPage1.currentPage"
            :page-size="productTagPage1.pageSize"
            :total="productTagPage1.pageTotal"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
          ></el-pagination>
        </div>

        <div style="text-align: center">
          <eui-btn @click="handleConfirm">提交确认</eui-btn>
          <eui-btn type="secondary" @click="handleCancelEdit">取消</eui-btn>
        </div>
      </div>
    </el-dialog>
    <AddProductDialog
      v-if="productListDialogShow"
      :material-code="materialCode"
      :agreement-origin="agreementOrigin"
      :agreement-detail="agreementDetail"
      :visible="productListDialogShow"
      @close="closeProductListDialog"
      @refreshProduct="getProductPriceList"
    ></AddProductDialog>
    <AdjustPriceDialog
      v-if="adjustPriceDialogShow"
      :agreement-id="agreementId"
      :visible="adjustPriceDialogShow"
      :price-id="priceId"
      :supplier-company-id="supplierCompanyId"
      @close="closeAdjustPriceDialog"
      @refresh="getProductPriceList"
    ></AdjustPriceDialog>
    <multi-adjust-price-dialog
      v-if="multiAdjustPriceDialogShow"
      :visible="multiAdjustPriceDialogShow"
      :price="adjustPrice"
      @handleAdjustPrice="multiAdjustPrice"
      @close="handleClose"
    ></multi-adjust-price-dialog>

    <!-- 所属分类 -->
    <ClassifyTree
      v-if="classifyVisible"
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyVisible = false"
    ></ClassifyTree>

    <ViewImportResultDialog :import-result-visible.sync="importResultVisible" />
    <ImportTemplateDialog v-if="importVisible" :import-visible.sync="importVisible" @refresh="handleSearch" />
  </div>
</template>

<script>
import utils, { fileExportResponseError } from '@/modules/projectA/utils/utils';
import ESearch from '@/modules/projectA/components/common/e-search';
import TableList from '@/modules/projectA/components/common/e-table-list';
import Api from '../../api/agreement/index';
import AddProductDialog from '../../components/agreement/agreementManage/productAddDialog';
import AdjustPriceDialog from '../../components/agreement/agreementManage/adjustPriceDialog';
import MultiAdjustPriceDialog from '../../components/agreement/agreementManage/multiAdjustPriceDialog';
import ViewImportResultDialog from './components/ViewImportResultDialog.vue';
import ImportTemplateDialog from './components/ImportTemplateDialog.vue';
import ClassifyTree from './components/classifyTree.vue';

export default {
  name: 'MaintenanceGoods',
  components: {
    TableList,
    AddProductDialog,
    AdjustPriceDialog,
    MultiAdjustPriceDialog,
    ViewImportResultDialog,
    ImportTemplateDialog,
    ESearch,
    ClassifyTree,
  },
  props: {},
  data() {
    return {
      agreementDetail: '',
      loading: false,
      tableData: [],
      tableLabel: [{ label: '企业名称', param: 'companyName', align: 'center' }],
      loading1: false,
      tableData1: [],
      tableLabel1: [
        { label: '图片', param: 'defaultImage', align: 'center', slot: 'image' },
        { label: '商品名称', param: 'skuName', align: 'center', slot: 'skuName' },
        { label: '商品编号', param: 'skuCode', align: 'center' },
        { label: '类目名称', param: 'categoryName', align: 'center' },
        { label: '计量单位', param: 'unitValue', align: 'center' },
        {
          label: '协议价（元）',
          param: 'agreementPrice',
          width: '130',
          align: 'center',
          slot: 'agreementPrice',
        },
        { label: '市场价（元）', param: 'price', align: 'center' },
        { label: '优惠比例', param: 'rate', align: 'center', slot: 'rate' },
        { label: '变更内容', param: 'operateSign', align: 'center', slot: 'operateSign' },
        { label: '协议价状态', param: 'status', align: 'center', slot: 'status' },
        { label: '操作', align: 'center', slot: 'operation', width: '130' },
      ],
      productTagPage1: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      agreementConfirm: 1,
      indexShow: true,
      agreementId: this.$route.params.agreementId,
      productListDialogShow: false,
      priceId: '',
      adjustPriceDialogShow: false,
      loading2: false,
      tableData2: [],
      tableLabel2: [
        { label: '序号', param: 'index', align: 'center', width: '50px' },
        { label: '物料类别', param: 'categoryName', align: 'center' },
      ],
      productTagPage2: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      supplierCompanyId: '',
      tableData3: [],
      quickNavActive: 0,
      loading3: false,
      tableData4: [
        // {categoryId:1001,categoryName:"低合金工字钢",categoryCode:'232423',isAdd:0,unitValue:'个'},
      ],
      tableLabel4: [
        { label: '物料编码', param: 'materialCode', align: 'center' },
        { label: '物料名称', param: 'materialName', align: 'center' },
        { label: '物料描述', param: 'materialDesc', align: 'center' },
        {
          label: '是否添加商品',
          param: 'hasSku',
          width: '200',
          align: 'center',
          slot: 'isAddProduct',
        },
        { label: '操作', align: 'center', slot: 'operation' },
      ],
      pager: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      categoryVisible: false,
      editFlag: false,
      agreementOrigin: false, // false代表正常创建的协议，true代表从其他平台推送过来的协议
      tableLabel5: [
        { label: '图片', param: 'defaultImage', align: 'center', slot: 'image' },
        { label: '商品名称', param: 'skuName', align: 'center', slot: 'skuName', width: '200' },
        { label: '商品编号', param: 'skuCode', align: 'center' },
        { label: '计量单位', param: 'unitValue', align: 'center' },
        { label: '协议价（元）', param: 'agreementPrice', align: 'center' },
        { label: '市场价（元）', param: 'price', align: 'center' },
        { label: '优惠比例', param: 'rate', align: 'center', slot: 'rate' },
        { label: '协议价状态', param: 'status', align: 'center', slot: 'status' },
        { label: '操作', align: 'center', slot: 'operation' },
      ],
      agreementPrice: '',
      materialCode: '',
      checkAll: false,
      multiAdjustPriceDialogShow: false,
      checkedSkuPriceMap: [],
      adjustPrice: 0,
      checkAllCount: 0,
      query: {
        skuName: '',
        skuCode: '',
        categoryIdList: [],
      },

      importResultVisible: false,
      importVisible: false,

      exportProductLoading: false,

      classifyVisible: false,
      defaultCheckedKeys: [],
      categoryTreeData: [],
      filterInfo: {
        data: {
          skuCode: null,
          skuName: null,
          categoryName: null,
        },
        fieldList: [
          { label: '商品编号', type: 'input', value: 'skuCode', width: '180' },
          { label: '商品名称', type: 'input', value: 'skuName' },
          {
            label: '类目名称',
            type: 'dialog',
            value: 'categoryName',
            placeholder: '支持多选',
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.agreementId = this.$route.query.agreementId;
    this.getAgreementDetail();

    this.getMdmTypeList();

    this.getCheckedDataCount();
  },
  methods: {
    // 获取分类树数据
    async getAllCategoryTree() {
      const res = await Api.queryCentralizedCategoryTreeByAgreementId({
        agreementId: this.agreementId,
      });
      if (res.code === '200') {
        this.categoryTreeData = res.data.children;
      }
    },
    // 选择所属分类
    focusClassify() {
      this.getAllCategoryTree();
      if (this.query.categoryIdList?.length) {
        this.defaultCheckedKeys = this.query.categoryIdList;
      }
      this.classifyVisible = true;
    },
    // 所属分类确定
    classifySubmitPopupData(val) {
      const filterNode = [];
      val.forEach((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.query.categoryIdList = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.filterInfo.data.categoryName = arr.join('、');
      this.classifyVisible = false;

      console.log(this.query.categoryIdList, this.filterInfo.data.categoryName);
    },
    async handleExportProduct() {
      this.exportProductLoading = true;
      const params = {
        agreementId: this.agreementId,
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
        materialCode: this.materialCode,
        skuCode: this.query.skuCode,
        skuName: this.query.skuName,
        categoryIdList: this.query.categoryIdList,
      };
      const res = await Api.exportSkuPrice(params);
      this.exportProductLoading = false;
      if (res.type === 'application/json') {
        fileExportResponseError(res);
      } else {
        utils.downFile(res, '协议商品');
      }
    },
    handleDeleteBatch() {
      if (this.checkedSkuPriceMap.length === 0) {
        this.$message.warning('请选择需要删除的商品');
        return;
      }
      this.$confirm('确定要移除选择的商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const ids = this.checkedSkuPriceMap.map((item) => item.priceId);
        const res = await Api.batchRemoveAgreement(ids);
        if (res.code === '200') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.handleSearch();
        }
      });
    },
    handleResultView() {
      this.importResultVisible = true;
    },
    handleImportPrice() {
      this.importVisible = true;
    },
    handleButton() {},
    handleSortChange() {},
    handleSelectionChange() {},
    handleButton1() {},
    handleSortChange1() {},
    handleSelectionChange1(val) {
      this.checkedSkuPriceMap = val;
    },
    handleSizeChange1(val) {
      this.productTagPage1.pageSize = val;
      this.productTagPage1.currentPage = 1;
      this.getProductPriceList();
    },
    handleCurrentChange1(val) {
      this.productTagPage1.currentPage = val;
      this.getProductPriceList();
    },
    formatRate(val) {
      return `${(((val.price - val.agreementPrice) / val.price) * 100).toFixed(2)}%`;
    },
    formatConfirmStatus(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '未提交';
          break;
        case 1:
          res = '待确认';
          break;
        case 2:
          res = '已确认';
          break;
        case 3:
          res = '拒绝';
          break;
        case 4:
          res = '已停用';
          break;
        default:
          break;
      }
      return res;
    },
    formatOperateSign(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '新增';
          break;
        case 1:
          res = '调价';
          break;
        case 2:
          res = '删除';
          break;
        default:
          break;
      }
      return res;
    },
    async getProductPriceList() {
      const params = {
        agreementId: this.agreementId,
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
        pageSize: this.productTagPage1.pageSize,
        pageNum: this.productTagPage1.currentPage,
        materialCode: this.materialCode,
        skuCode: this.query.skuCode,
        skuName: this.query.skuName,
        categoryIdList: this.query.categoryIdList,
      };
      const that = this;
      // todo 迭代152022/8/1搜索功能接口还没开发完 参数已经添加完毕
      const res = await Api.getProductPriceList(params);

      if (res.data) {
        this.tableData1 = res.data.records;
        if (this.agreementOrigin) {
          for (let i = 0; i < this.tableData1.length; i++) {
            this.$set(this.tableData1[i], 'agreementPrice', this.agreementPrice);
          }
        }
        this.productTagPage1.pageTotal = res.data.total;

        if (that.checkAll) {
          that.$nextTick(() => {
            that.tableData1.forEach((item, index) => {
              that.$refs.table.$refs.table.toggleRowSelection(that.tableData1[index], true);
            });
          });
        }
      }
    },
    handleAddProduct() {
      this.productListDialogShow = true;
    },
    closeProductListDialog() {
      this.productListDialogShow = false;
    },
    handleAdjustPrice(val) {
      this.priceId = val.priceId;
      this.supplierCompanyId = this.agreementDetail.supplierCompanyId;
      this.adjustPriceDialogShow = true;
    },
    handleDelete(val) {
      const params = {
        priceId: val.priceId,
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
      };
      Api.deleteAgreementPrice(params).then((res) => {
        if (res.code === '200') {
          this.$message({
            type: 'success',
            message: res.data,
          });

          this.getProductPriceList();
        }
      });
    },
    handleConfirm() {
      const params = {
        agreementId: this.agreementId,
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
        materialCode: this.agreementOrigin ? this.materialCode : '',
      };
      for (let i = 0; i < this.tableData1.length; i++) {
        if (!this.tableData1[i].agreementPrice) {
          this.$message({
            type: 'warning',
            message: '请填写协议价',
          });
          return;
        }
      }
      if (this.agreementOrigin) {
        Api.supplierSubmitConfirmfromSCM(params).then((res) => {
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '提交确认成功',
            });
            this.categoryVisible = false;
            this.getCategoryList();
            // this.$router.push({path:'/scAgreementManage'})
          }
        });
      } else {
        Api.supplierSubmitConfirm(params).then((res) => {
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '添加商品成功',
            });
            this.$router.push({ path: '/scAgreementManage' });
          }
        });
      }
    },
    handleCancel() {
      this.goToUrl();
    },
    goToUrl() {
      this.$store.state.tagsList.forEach((item, index) => {
        if (item.fullPath === this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.go(-1);
    },
    adjustAgreementPrice(val) {
      const params = {
        priceId: val.priceId,
        agreementPrice: parseFloat(val.agreementPrice),
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
      };

      Api.updateAgreementPriceByAdd(params).then((res) => {
        if (res.code === '200') {
          this.$message({
            type: 'success',
            message: '更新协议价成功',
          });
        }
      });
    },
    closeAdjustPriceDialog() {
      this.adjustPriceDialogShow = false;
      setTimeout(() => {
        this.getProductPriceList();
      }, 2000);
    },
    handleSizeChange(val) {
      this.productTagPage2.pageSize = val;
      this.productTagPage2.currentPage = 1;
      this.getMdmTypeList();
    },
    handleCurrentChange(val) {
      this.productTagPage2.currentPage = val;
      this.getMdmTypeList();
    },
    getMdmTypeList() {
      const params = {
        agreementId: this.$route.query.agreementId,
      };

      Api.getMdmTypeList(params).then((res) => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            if ((i + 1) % 2 === 0) {
              this.$set(res.data[i], 'index', i + 1);
              this.tableData2.push(res.data[i]);
            } else {
              this.$set(res.data[i], 'index', i + 1);
              this.tableData3.push(res.data[i]);
            }
          }
        }
      });
    },
    handleDownload(val) {
      window.open(val);
    },
    async getAgreementDetail() {
      const params = {
        agreementId: this.agreementId,
      };
      const res = await Api.getAgreementDetail(params);

      if (res.data) {
        this.agreementDetail = res.data;
        this.agreementOrigin = this.agreementDetail.source
          ? this.agreementDetail.source === 'SL' || this.agreementDetail.source === 'SC'
          : false;
        this.tableData = res.data.agreementMembers;
      }

      if (!this.agreementOrigin) {
        // 如果商品是正常创建的就调接口
        this.getProductPriceList();
      } else {
        // 如果是从SCM推送过来的
        this.getCategoryList();
      }
    },
    handleButton3() {},
    handleSortChange3() {},
    handleSelectionChange3() {},
    handleSizeChange3(val) {
      this.pager.pageSize = val;
      this.pager.currentPage = 1;
      this.getCategoryList();
    },
    handleCurrentChange3(val) {
      this.pager.currentPage = val;
      this.getCategoryList();
    },
    async getCategoryList() {
      const params = {
        agreementId: this.agreementId,
        pageSize: this.pager.pageSize,
        pageNum: this.pager.currentPage,
      };
      const res = await Api.getCategoryList(params);

      if (res.data) {
        this.tableData4 = res.data;
        this.pager.pageTotal = res.data.total;
      }
    },
    formateAddProduct(val) {
      if (val === false) {
        return '否';
      }
      return '是';
    },
    checkDetail() {
      this.editFlag = false;
      this.categoryVisible = true;
    },
    handleEditCategory(val) {
      this.editFlag = true;
      this.categoryVisible = true;
      this.agreementPrice = val.materialPrice;
      this.materialCode = val.materialCode;
      this.getProductPriceList();
    },
    handleCancelEdit() {
      this.getCategoryList();
      this.categoryVisible = false;
    },
    handleMultiAdjustPrice() {
      if (this.checkedSkuPriceMap.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.multiAdjustPriceDialogShow = true;
      const priceArr = this.checkedSkuPriceMap.map((item) => item.price);
      this.adjustPrice = Math.min(...priceArr);
    },
    handleCheckAllChange(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.table.$refs.table.toggleAllSelection();
        });
        this.getAllProductPriceList();
      } else {
        this.checkedSkuPriceMap = []; // 清空当前列表页选择的数据项
        this.$refs.table.$refs.table.clearSelection(); // 清除全部的选中状态
      }
    },
    async multiAdjustPrice(val) {
      const params = { ...val };
      params.supplierCompanyId = this.agreementDetail.supplierCompanyId;
      params.agreementPrices = this.checkedSkuPriceMap;
      const res = await Api.multiAdjustPrice(params);
      if (res.code === '200') {
        this.multiAdjustPriceDialogShow = false;
        this.$message({
          message: '多维度调价成功！',
          type: 'success',
        });

        this.clearTable();
        setTimeout(() => {
          this.getProductPriceList();
        }, 1000);
      }
    },
    clearTable() {
      this.checkedSkuPriceMap = []; // 清空当前列表页选择的数据项
      this.$refs.table.$refs.table.clearSelection(); // 清除全部的选中状态
      this.checkAll = false;
    },
    async getAllProductPriceList() {
      const params = {
        agreementId: this.agreementId,
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
        materialCode: this.materialCode,
      };
      const res = await Api.getAllProductPriceList(params);

      if (res.data) {
        this.checkedSkuPriceMap = res.data;
      }
    },
    async getCheckedDataCount() {
      const params = {
        agreementId: this.agreementId,
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
        materialCode: this.materialCode,
      };
      const res = await Api.getAllProductPriceList(params);

      if (res.data) {
        this.checkAllCount = res.data.length;
      }
    },
    handleClose() {
      this.multiAdjustPriceDialogShow = false;
      this.clearTable();
      setTimeout(() => {
        this.getProductPriceList();
      }, 2000);
    },
    handleSelect(rows) {
      if (this.checkAllCount === rows.rows.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    handleSelectAll(rows) {
      if (rows.length === 0) {
        this.checkAll = false;
      }
    },
    handleSearch(val) {
      this.query = { ...this.query, ...val };
      console.log();
      this.productTagPage1.pageSize = 10;
      this.productTagPage1.currentPage = 1;
      this.getProductPriceList();
      this.handleCheckAllChange();
      this.$nextTick(() => {
        this.$refs.table.$refs.table.clearSelection(); // 清除全部的选中状态
      });
    },
    handleClear() {
      this.query.skuName = '';
      this.query.skuCode = '';
      this.query.categoryIdList = [];
      this.filterInfo.data.categoryName = '';
      this.getProductPriceList();
      this.handleCheckAllChange();
      this.$nextTick(() => {
        this.$refs.table.$refs.table.clearSelection(); // 清除全部的选中状态
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.agreement-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .agreement-container {
    background: #fff;
    margin-bottom: 10px;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
    width: 100%;
    display: flex;
    flex-direction: column;
    /*align-items: center;*/
    padding: 20px 20px;
    .container-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
      width: 100%;
    }
    .container-btn {
      width: 100%;
      margin-bottom: 10px;
    }
    .container-body {
      width: 100%;
      .el-input-width {
        width: 266px;
        height: 28px;
      }
      .container-purchase {
        background: #f8f8f8;
        width: 725px;
        height: 424px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        .left {
          width: 308px;
          height: 360px;
          background-color: #ffffff;
          padding: 10px 10px 10px;
          .search {
            width: 100%;
            .scrollbar {
              height: 242px;
              overflow: hidden;
            }
          }
        }
        .right {
          width: 298px;
          height: 360px;
          background-color: #ffffff;
          padding: 10px 10px 10px;
          .scrollbar {
            height: 316px;
            overflow: hidden;
            .scrollbar-li {
              display: flex;
              justify-content: space-between;
              cursor: pointer;
            }
            .scrollbar-active {
              background: #f4f7ff;
            }
          }
        }
        .middle {
          width: 60px;
          height: 360px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            height: 35px;
            width: 18px;
          }
        }
        .tip {
          font-size: 14px;
          color: #999999;
        }
      }
      .tabs-area {
        margin-bottom: 20px;
        .scrollbar {
          height: 290px;
          overflow: hidden;
          .table {
            display: flex;
            flex-direction: row;
          }
        }
      }
    }
  }
}

.scrollbar ::v-deep .el-scrollbar__wrap {
  overflow: hidden;
  margin-right: 0 !important;
}
.scrollbar ::v-deep .el-scrollbar__bar.is-vertical {
  background: #f5f5f5;
  border-radius: 2px;
  width: 3px;
  opacity: 1;
  margin-right: -2px;
}
.scrollbar ::v-deep .el-scrollbar__bar.is-horizontal {
  background: #f5f5f5;
  border-radius: 2px;
  height: 3px;
  margin-bottom: -2px;
  &:hover {
    opacity: 0;
  }
}
.tabs-area ::v-deep .el-tabs__header {
  margin: 0 0 0 !important;
}
.tabs-area ::v-deep .el-tabs__header .el-tabs__nav {
  border-radius: 0 !important;
}
.table ::v-deep .el-table__empty-block {
  min-height: 0 !important;
}
.table ::v-deep .el-table__empty-text {
  display: none;
}
::v-deep {
  .el-rate__icon {
    font-size: 20px;
    margin-right: 2px;
  }

  .tabs-area {
    .el-tabs__nav {
      border-radius: 0;
    }

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__nav .el-tabs__item {
      width: 176px;
      text-align: center;
      font-size: 14px;
      line-height: 40px;
      height: 40px;

      &.is-active {
        background: #f4f7ff;
        color: #0064c8;
      }

      &.is-active::after {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        content: '';
        width: 100%;
        height: 2px;
        background: #0064c8;
      }
    }
    .el-tabs__content {
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
    }
  }
}

.check-btn::v-deep.el-button {
  border: 1px solid #2587ff;
  background: #fff;
  color: #2587ff;
  margin-left: 30px;
}
.check-btn::v-deep.el-button:hover {
  background: #e8efff;
  text-decoration: none;
}
::v-deep.el-button:hover {
  background: #e8efff;
  text-decoration: none;
}
</style>
